import { render, staticRenderFns } from "./EmailNodeProperties.vue?vue&type=template&id=c1a901b8&scoped=true"
import script from "./EmailNodeProperties.vue?vue&type=script&lang=js"
export * from "./EmailNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./EmailNodeProperties.vue?vue&type=style&index=0&id=c1a901b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a901b8",
  null
  
)

export default component.exports